/**
 * level item view Class for editor backlog
 */
export class EditorBacklogLevelView extends Phaser.Group {
  /**
   * constructor
   * @param {number} x
   * @param {number} y
   */
  constructor(x, y) {
    super(game);
    this.position.setTo(x, y);
    this.onClicked = new Phaser.Signal();
  }

  init(levelId) {
    this._cleanup();
    if (!levelId) return;
    this._makeLevelThumbnail(levelId);
    this._makeLevelIDLabel(levelId);
  }

  /**
   * make level preview thumbnail
   * @param {string} levelId
   */
  _makeLevelThumbnail(levelId) {
    const { levelDataMgr } = G.Helpers;
    const thumbnailGenerator = G.Helpers.levelThumbnailGenerator;
    this.thumbnail = thumbnailGenerator.generateImage(levelDataMgr.getLevelById(levelId), 150, 150);
    this.add(this.thumbnail);

    this.thumbnail.inputEnabled = true;
    this.thumbnail.input.useHandCursor = true;
    this.thumbnail.events.onInputDown.add(() => {
      this.onClicked.dispatch(levelId);
    });
  }

  /**
   * make level ID label
   * @param {string} levelId
   */
  _makeLevelIDLabel(levelId) {
    this.levelId = this.add(new G.Text(0, this.thumbnail.height, levelId, {
      style: 'editor',
      fontSize: 20,
    }, [0, 1]));
  }

  /**
   * cleanup elements
   */
  _cleanup() {
    if (this.thumbnail) {
      this.thumbnail.destroy();
      this.thumbnail = null;
    }
    if (this.levelId) {
      this.levelId.destroy();
      this.levelId = null;
    }
  }

  /**
   * destruction method
   */
  destroy() {
    super.destroy();
    this._cleanup();
  }
}
